<template>
  <q-layout :view="view" :container="container">
    <slot />
  </q-layout>
</template>

<script>
export default {
  name: 'Layout',
  props: {
    view: {
      type: String,
      default: 'hHh lpR fFf',
    },
    container: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
